module.exports = __webpack_public_path__ + "media/images/number_27-9b42d709035aa3363831121f64d8c4c7.png";